import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { disableReactDevTools } from "@fvilers/disable-react-devtools";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

document.addEventListener("contextmenu", (event) => {
  event.preventDefault();
  return false;
});
document.addEventListener("keydown", function (event) {
  if (event.ctrlKey && event.shiftKey && event.key === "C") {
    event.preventDefault();
    return false;

    // Your custom code here
  }
});
document.addEventListener("keydown", function (event) {
  if (event.ctrlKey && event.shiftKey && event.key === "I") {
    event.preventDefault();
    return false;

    // Your custom code here
  }
});
document.addEventListener("keydown", function (event) {
  if (event.key === "F12") {
    event.preventDefault();
    return false;
    // Your custom code here
  }
});

if (process.env.NODE_ENV === "production") {
  disableReactDevTools();
}

root.render(
  <Router>
    <App />
  </Router>
);
